/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Button, Colors, Spacer, Typography } from '@zapier/design-system';

import { SizeType } from '@zapier/product-get-help/src/types';

import List from '@zapier/product-get-help/src/components/shared/List';
import Surface from '@zapier/product-get-help/src/components/shared/Surface';
import ExternalLink from '@zapier/product-get-help/src/components/shared/ExternalLink';

import ConversationLink from './ConversationLink';

type Link = {
  href: string;
  title: string;
  snippet?: string;
};

type CommunityStepProps = {
  /** Conversations to link */
  links: Link[];
  /** Size to display. */
  size?: SizeType;
};

const RebrandStyles = {
  browseLink: {
    ...Typography.smallPrint1Bold,
    color: Colors.blueJeans,
  },
  buttonIntro: {
    ...Typography.paragraph1ShortBold,
    color: Colors.neutral800,
  },
};

/** Renders the content for the community-step in the form. */
const CommunityStep = ({ links, size = 'large' }: CommunityStepProps) => {
  return (
    <Surface size={size} title="Find a solution in our Community">
      <Spacer height={14} />
      <List
        gap={5}
        itemRenderer={(item: Link) => (
          <ConversationLink {...item} size={size} />
        )}
        items={links}
      />
      <Spacer height={20} />
      <ExternalLink
        css={RebrandStyles.browseLink}
        href="https://community.zapier.com/ask-the-community-3"
      >
        Browse Community
      </ExternalLink>
      <Spacer height={40} />
      <p css={RebrandStyles.buttonIntro}>You can also ask your own question</p>
      <Spacer height={15} />
      <Button
        color="secondary"
        href="https://community.zapier.com/topic/new"
        target="_blank"
      >
        Ask our Community
      </Button>
    </Surface>
  );
};

export default CommunityStep;
